import PermissionRoute from '@Src/_basic/helpers/PermissionRoute';
import { RouteConfig } from '@Src/app/BasicRouter';
import React, { memo } from 'react';
import ApiGroupManagementScreen from './screens/ApiGroupManagementScreen';

const routesConfig: RouteConfig[] = [
  {
    path: '/',
    element: <ApiGroupManagementScreen />,
  },
];

const ApiGroupManagementRouter = () => PermissionRoute(routesConfig);

export default memo(ApiGroupManagementRouter);
